import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

// local imports
import InformationBox from 'components/InformationBox';
import * as S from './styles';

export const NotSickContent = () => {
  const [emailInputValue, setEmailInputValue] = useState('');
  const { register, errors } = useForm({
    mode: 'onBlur',
  });

  const handleChange = (e: any) => {
    setEmailInputValue(e.target.value);
  };

  useEffect(() => {}, [emailInputValue]);

  return (
    <>
      <S.Heading>You are not eligible for testing at this time. </S.Heading>
      <S.ContentInner>
        <S.P>
          We are required to prioritize tests for individuals with the most
          urgent need.
        </S.P>
        <S.P>
          Should you begin to experience symptoms, it is very important to stay
          home and limit your interaction with others in your household and in
          public.
        </S.P>
        <S.P>
          Contact your healthcare provider if your symptoms get worse or you
          experience any new symptoms.
        </S.P>
        <S.ListHeading>
          Seek medical attention if you experience any of the following:
        </S.ListHeading>
        <S.UL>
          <S.LI>Severe shortness of breath</S.LI>
          <S.LI>Continuous pain or pressure in the chest</S.LI>
          <S.LI>Persistent fever greater than 102°F</S.LI>
        </S.UL>
        <InformationBox text="If at any time you feel like you are having a medical emergency, please call 9-1-1." />
        <S.SignUpHeading>Sign up for updates</S.SignUpHeading>
        <S.P>
          Sign up for updates, including when we can provide testing to you.
        </S.P>
        <S.Form
          name="iterable_optin"
          action="//links.iterable.com/lists/publicAddSubscriberForm?publicIdString=bcc0942f-2273-42ca-af67-c38ee5d67fe3"
          target="_blank"
          method="POST"
          className="email"
        >
          <S.Label className="label-text">Email</S.Label>
          <S.EmailInput
            type="text"
            id="emailInput"
            name="emailInput"
            value={emailInputValue}
            onChange={handleChange}
            placeholder="Email"
            ref={register({
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: 'invalid email address',
              },
            })}
            error={errors.emailInput && errors.emailInput.message}
          />
          <S.SubmitInput type="submit" value="Notify Me" />
        </S.Form>
      </S.ContentInner>
    </>
  );
};

export default NotSickContent;
